import EA from '../helpers/init';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default EA.Methods.animFadeBottom = ($this) => {
    const init = function () {
        let offset = $this.getAttribute('data-offset') || '30%';
        const autoplay = $this.getAttribute('data-autoplay') || false;
        const fadeInEls = $this.querySelectorAll('.anim-fade-up');

        if (window.innerWidth < 600) {
            offset = '30%';
        }

        // Settings
        let stagger = 0.35;
        const minStagger = 0.17;
        const childrenCount = fadeInEls.length;
        const decrement = -0.03;


        gsap.config({
            nullTargetWarn: false
        });

        // Faster fade speed if there are a lot of children
        if (childrenCount > 4) {
            for (let i = 3; i < childrenCount; i++) {
                stagger += decrement;
                stagger = Math.max(minStagger, stagger);
            }
        }

        const onDone = () => {
            $this.classList.add('anims-done');
            $this.querySelectorAll('.anim-fade-up').forEach(el => el.style = '');
        };

        gsap.set(fadeInEls, {
            y: 20,
            opacity: 0
        });

        if (autoplay) {
            gsap.timeline({ onComplete: onDone })
                .to(fadeInEls, {
                    y: 0,
                    opacity: 1,
                    duration: 0.75,
                    stagger,
                    ease: 'power3.out',
                    clearProps: 'y,opacity',
                });
            return;
        }

        // Creating timeline
        // const tl = gsap.timeline({
        //     scrollTrigger: {
        //         trigger: $this,
        //         start: `${offset} 70%`,
        //         end: 'bottom 50%',
        //     },
        //     onComplete: onDone,
        // });

        // tl.fromTo(fadeInEls, {
        //     y: 20,
        //     opacity: 0
        // }, {
        //     y: 0,
        //     opacity: 1,
        //     duration: 0.75,
        //     stagger: stagger,
        //     ease: 'power3.out',
        // });

        // Batch: each element triggers when it enters, with a small local stagger.
        ScrollTrigger.batch(fadeInEls, {
            start: `${offset} 70%`,
            once: true,
            interval: 0.12,
            batchMax: 6,
            onEnter: (elements) => {
                gsap.to(elements, {
                    y: 0,
                    opacity: 1,
                    duration: 0.75,
                    stagger: 0.12,
                    ease: 'power3.out',
                    clearProps: 'y,opacity',
                    overwrite: 'auto',
                    onComplete: () => {
                        const allDone = [...fadeInEls].every(el => el.style.opacity === '' || el.style.opacity === '1' || el.classList.contains('gsap-done'));
                        if (allDone) onDone();
                    },
                });
            },
        });
    };

    const intersectionObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];

        if (!entry.isIntersecting) return;

        intersectionObserver.disconnect();
        init();
        ScrollTrigger.refresh();
    },
    {
        root: null,
        threshold: 0,
        rootMargin: '100px',
    });

    intersectionObserver.observe($this);
};
